import createAsyncAction from "../../../utils/async_action_utils";
import * as api from "../../api/conference/conference_api";
import * as types from "../../constants/conference/conference_constants";

const getConferenceTypes = {
  success: types.GET_CONFERENCE_SUCCESS,
  failure: types.GET_CONFERENCE_FAILURE,
};

const conferencePaidType = {
  success: types.CONFERENCE_PAID_SUCCESS,
  failure: types.CONFERENCE_PAID_FAILURE,
};

const conferenceRegisteredType = {
  success: types.CONFERENCE_REGISTER_SUCCESS,
  failure: types.CONFERENCE_REGISTER_FAILURE,
};

const conferenceNeedsTypes = {
  success: types.CONFERENCE_NEEDS_SUCCESS,
  failure: types.CONFERENCE_NEEDS_FAILURE,
};

const getConferenceParticipantTypes = {
  success: types.GET_CONFERENCE_PARTICIPANT_SUCCESS,
  failure: types.GET_CONFERENCE_PARTICIPANT_FAILURE,
};

const addConferenceTypes = {
  success: types.ADD_CONFERENCE_SUCCESS,
  failure: types.ADD_CONFERENCE_FAILURE,
};

const manualConferenceTypes = {
  success: types.MANUAL_CONFERENCE_SUCCESS,
  failure: types.MANUAL_CONFERENCE_FAILURE,
};

const updateConferenceTypes = {
  success: types.UPDATE_CONFERENCE_SUCCESS,
  failure: types.UPDATE_CONFERENCE_FAILURE,
};

const deleteConferenceTypes = {
  success: types.DELETE_CONFERENCE_SUCCESS,
  failure: types.DELETE_CONFERENCE_FAILURE,
};

const getConferenceExemptTypes = {
  success: types.GET_CONFERENCE_EXEMPT_SUCCESS,
  failure: types.GET_CONFERENCE_EXEMPT_FAILURE,
};

const addConferenceExemptTypes = {
  success: types.ADD_CONFERENCE_EXEMPT_SUCCESS,
  failure: types.ADD_CONFERENCE_EXEMPT_FAILURE,
};

const deleteConferenceExemptTypes = {
  success: types.DELETE_CONFERENCE_EXEMPT_SUCCESS,
  failure: types.DELETE_CONFERENCE_EXEMPT_FAILURE,
};

const deleteConferencePartTypes = {
  success: types.DELETE_PART_SUCCESS,
  failure: types.DELETE_PART_FAILURE,
};

const conferenceFilterTypes = {
  success: types.CONFERENCE_FILTER_SUCCESS,
  failure: types.CONFERENCE_FILTER_FAILURE,
};

const conferenceManualListTypes = {
  success: types.CONFERENCE_MANUAL_AUTHORIZATION_LIST_SUCCESS,
  failure: types.CONFERENCE_MANUAL_AUTHORIZATION_LIST_FAILURE,
};

const conferenceManualDeleteTypes = {
  success: types.CONFERENCE_MANUAL_DELETE_SUCCESS,
  failure: types.CONFERENCE_MANUAL_DELETE_FAILURE,
};

const conferenceTransportTypes = {
  success: types.CONFERENCE_TRANSPORTATION_SUCCESS,
  failure: types.CONFERENCE_TRANSPORTATION_FAILURE,
};

const conferenceCrecheTypes = {
  success: types.CONFERENCE_CRECHE_SUCCESS,
  failure: types.CONFERENCE_CRECHE_FAILURE,
};

const conferenceManualApproveTypes = {
  success: types.CONFERENCE_MANUAL_APPROVE_SUCCESS,
  failure: types.CONFERENCE_MANUAL_APPROVE_FAILURE,
};

const conferenceExemptSearchTypes = {
  success: types.SEARCH_CONFERENCE_EXEMPT_SUCCESS,
  failure: types.SEARCH_CONFERENCE_EXEMPT_FAILURE,
};

const conferenceMiscFilterTypes = {
  success: types.CONFERENCE_MISC_FILTER_SUCCESS,
  failure: types.CONFERENCE_MISC_FILTER_FAILURE,
};

const conferenceNeedsFilterTypes = {
  success: types.CONFERENCE_NEEDS_FILTER_SUCCESS,
  failure: types.CONFERENCE_NEEDS_FILTER_FAILURE,
};

export const getConference = createAsyncAction(
  api.getConference,
  getConferenceTypes
);

export const conferencePaid = createAsyncAction(
  api.conferencePaid,
  conferencePaidType
);

export const conferenceRegister = createAsyncAction(
  api.conferenceRegister,
  conferenceRegisteredType
);

export const conferenceNeeds = createAsyncAction(
  api.conferenceNeeds,
  conferenceNeedsTypes
);

export const addConference = createAsyncAction(
  api.addConference,
  addConferenceTypes
);

export const manualConference = createAsyncAction(
  api.manualConference,
  manualConferenceTypes
);

export const updateConference = createAsyncAction(
  api.updateConference,
  updateConferenceTypes
);

export const deleteConferencePart = createAsyncAction(
  api.deletePart,
  deleteConferencePartTypes
);

export const deleteConference = createAsyncAction(
  api.deleteConference,
  deleteConferenceTypes
);

export const getConferenceParticipant = createAsyncAction(
  api.getConferenceParticipant,
  getConferenceParticipantTypes
);

export const getConferenceExempt = createAsyncAction(
  api.getConferenceExempt,
  getConferenceExemptTypes
);

export const addConferenceExempt = createAsyncAction(
  api.addConferenceExempt,
  addConferenceExemptTypes
);

export const deleteConferenceExempt = createAsyncAction(
  api.deleteConferenceExempt,
  deleteConferenceExemptTypes
);

export const conferenceFilter = createAsyncAction(
  api.conferenceFilter,
  conferenceFilterTypes
);

export const conferenceManualListAction = createAsyncAction(
  api.conferenceManualList,
  conferenceManualListTypes
);

export const conferenceManualDeleteAction = createAsyncAction(
  api.conferenceManualDelete,
  conferenceManualDeleteTypes
);

export const conferenceTransportAction = createAsyncAction(
  api.conferenceTransportList,
  conferenceTransportTypes
);

export const conferenceCrecheAction = createAsyncAction(
  api.conferenceCrecheList,
  conferenceCrecheTypes
);

export const conferenceManualApproveAction = createAsyncAction(
  api.conferenceManualApprove,
  conferenceManualApproveTypes
);

export const conferenceExemptSearchAction = createAsyncAction(
  api.searchConferenceExempt,
  conferenceExemptSearchTypes
);

export const conferenceMiscFilterAction = createAsyncAction(
  api.conferenceMiscFilter,
  conferenceMiscFilterTypes
);

export const conferenceNeedsFilterAction = createAsyncAction(
  api.conferenceNeedsFilter,
  conferenceNeedsFilterTypes
);

export const conferenceManualAddAction = (value) => async (dispatch) => {
  try {
    const response = await api.conferenceManualAdd(value);
    const { error } = response;

    if (error) {
      dispatch({
        type: types.CONFERENCE_MANUAL_AUTHORIZATION_ADD_FAILURE,
        payload: error,
      });
    } else {
      window.location.reload();
    }
  } catch (error) {
    dispatch({
      type: types.CONFERENCE_MANUAL_AUTHORIZATION_ADD_FAILURE,
      payload: "Something went wrong.",
    });
  }
};

// export const conferenceManualApproveAction = (value) => async (dispatch) => {
//   try {
//     const response = await api.conferenceManualApprove(value);
//     const { error } = response;

//     if (error) {
//       dispatch({
//         type: types.CONFERENCE_MANUAL_APPROVE_FAILURE,
//         payload: error,
//       });
//     } else {
//       window.location.reload();
//     }
//   } catch (error) {
//     dispatch({
//       type: types.CONFERENCE_MANUAL_APPROVE_FAILURE,
//       payload: "Something went wrong.",
//     });
//   }
// };
